import ApiConstant from "../ApiConstant/ApiConstant";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

let token = "";



const handleRequestError = (error) => {
    if (error.message.startsWith("Invalid origin")) {
      console.error(error.message);
      return error.message;
    }else if (!error.response) {
      // If it's a network error (no internet connection)
      console.error("Network Error:", error.message);
      return null;
    } else {
      throw error;
    }
  };

export const fetchToken = async() => {
  token = localStorage.getItem('authToken');
  if (token) {
    let decodedToken = jwtDecode(token);

    if (decodedToken && decodedToken.exp * 1000 > Date.now()){

    } else {
      alert("Token has expired, Login again!");
      localStorage.removeItem('authToken');
    }
  }
}



export const addProduct = async (product) => {
    fetchToken();
    console.log(product);
    try {
      const response = await axios.post(ApiConstant.baseApiProduct, product, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const uploadProductImage = async (productImage, productId, newProduct) => {
    fetchToken();
    try {
      const response = await axios.post(ApiConstant.baseApiProduct + `/upload-image/${productId}`, productImage, {
        params: {
            'newProduct': newProduct
        },
        headers: {
          Authorization : `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const editProduct = async (productId, product, imageChangeFlag) => {
    fetchToken();
    try {
      const response = await axios.put(ApiConstant.baseApiProduct + `/edit-product/${productId}`, product, {
        params: {
          'imageChange': imageChangeFlag
        },
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const deleteProduct = async (productId) => {
    fetchToken();
    try {
      const response = await axios.delete(ApiConstant.baseApiProduct + `/${productId}`, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const fetchProducts = async () => {
  // fetchToken();
  try {
    const response = await axios.get(ApiConstant.baseApiProduct);
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}

export const fetchProductsDetail = async (productId) => {
  // fetchToken();
  try {
    const response = await axios.get(ApiConstant.baseApiProduct + `/${productId}`);
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}





